<template>
  <dsf-exam-layout :exam-loading="examLoading">
    <template #header>
      <h3 style="text-align: center" v-if="examInfoData">
        {{ examInfoData.manageName }}
      </h3>
    </template>
    <template #left>
      <p class="sub-title list bg pd-10">答题卡</p>
      <div class="card-list">
        <!-- <el-row class="card-tips pd-10">
            <el-col :span="8" class="success">正确{{ answeredCount }}个</el-col>
            <el-col :span="8" class="error">错误1个</el-col>
            <el-col :span="8" class="not-answer">
              未答{{ markedCount }}个
            </el-col>
          </el-row> -->

        <template v-for="(data, index) in examInfoData.items">
          <p class="sub-title list pd-10" :key="'sub_' + index + data.examPaperId">
            {{ data.name }}
            <span class="sub"> （共{{ data.totalNum }}题，合计{{ data.totalScore }}分） </span>
          </p>
          <div class="question-list" :key="'list_' + index + data.examPaperId">
            <!-- <template v-for="(q, i) in data.questions">
                  <div :class="['item', q.resScore ? 'answered' : '']" :key="q.examPaperId" @click="toScroll(q.examQuestionsId)">
                    {{ ++i }}
                  </div>
                </template> -->
            <template v-for="(q, i) in data.questions">
              <div
                v-if="data.questionsItems.value != 'group'"
                :class="['item', q.resScore ? 'answered' : '', q.marked ? 'marked' : '']"
                :key="'item_' + q.examQuestionsId"
                @click="toScroll(q.examQuestionsId)"
              >
                {{ ++i }}
              </div>
              <template v-for="childValue in q.children" v-else>
                <div
                  :class="['item', childValue.resScore ? 'answered' : '', childValue.marked ? 'marked' : '']"
                  :key="'group_' + childValue.examQuestionsId"
                  @click="toScroll(childValue.examQuestionsId, childValue.groupIndex - 1)"
                >
                  {{ childValue.groupIndex }}
                </div>
              </template>
            </template>
          </div>
        </template>
      </div>
    </template>
    <template #main>
      <template v-for="(data, index) in examInfoData.items">
        <p class="sub-title list bg pd-20" :key="'title_' + data.examPaperItemsId">
          {{ dsf.math.toChinesNum(++index) + "、" + data.name }}
          <span class="sub" v-if="data.score && data.totalScore"> （共{{ data.questions.length }}题，合计{{ data.totalScore }}分） </span>
        </p>
        <div class="exam-content" :key="data.examPaperItemsId + index">
          <div class="question" v-for="(subjects, examIndex) in data.questions" :key="examIndex + subjects.examQuestionsId">
            <div class="left" :ref="'question' + subjects.examQuestionsId">
              <dsf-exam-item-box :subjects="subjects" :exam-index="examIndex" :readOnly="true" />
            </div>
            <div class="right">
              <div class="count">
                <!-- <p>
                      判题:
                      <i
                        @click="subjects.isRight = true"
                        class="iconfont icon-duigoux"
                        :class="{ active: subjects.isRight }"
                      ></i>
                      <i
                        @click="subjects.isRight = false"
                        class="iconfont icon-guanbi2"
                        :class="{ active: !subjects.isRight }"
                      ></i>
                    </p> -->
                <p>满分: {{ subjects.score }}分</p>
                <p style="position: relative">
                  {{ data.questionsItems.value === "group" ? "总分数" : "分 数" }}
                  <el-input
                    :disabled="data.questionsItems.value === 'group'"
                    size="small"
                    v-model="subjects.resScore"
                    style="width: 70px"
                    @input="groupScore(subjects)"
                    ref="examscore"
                    :class="{
                      'input-error': subjects.resScore > subjects.score,
                    }"
                  />
                  <span v-if="subjects.error" class="el-form-item__error">{{ subjects.message }}</span>
                </p>
                <template v-if="data.questionsItems.value === 'group'">
                  <div v-for="(childValue, childKey) in subjects.children" class="left_p" :key="childKey + childValue.examQuestionsId">
                    <!-- 第{{ childKey + 1 }}题 -->
                    <p>第{{ childKey + 1 }}题: {{ childValue.score }}分</p>
                    <!-- <span class="example-score m-score"> -->
                    <!-- {{ childValue.score }} -->
                    <!-- <el-input
                            size="small"
                            v-model="childValue.score"
                            style="width: 70px"
                            :disabled="$route.query.type == 1"
                            @input="resetQuestionScore(childValue, subjects, childKey)"
                          /> -->
                    <!-- 分
                        </span> -->
                    <p style="position: relative">
                      得
                      <span class="example-score m-score">
                        <!-- v-if="childValue.resScore >= 0" -->
                        <el-input
                          size="small"
                          v-model="childValue.resScore"
                          style="width: 70px"
                          ref="examscorechild"
                          :class="{
                            'input-error': childValue.resScore > childValue.score,
                          }"
                          @input="resetQuestionScore(childValue, subjects, childKey)"
                        />
                        分
                      </span>
                      <span v-if="childValue.error" class="el-form-item__error">{{ childValue.message }}</span>
                    </p>

                    <el-divider />
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template #right>
      <div class="item">
        <p class="txt">学员姓名</p>
        <p class="result">{{ examInfoData.examUserName }}</p>
      </div>
      <div class="item" v-if="type == 0">
        <p class="txt">剩余</p>
        <p class="result">{{ recordIds.remainNum }}份试卷</p>
      </div>
      <div class="item">
        <p class="txt">试卷总分</p>
        <p class="result">{{ examInfoData.totalScore }}分</p>
      </div>
      <dsf-setting-font-size />

      <div class="marking-post">
        <el-button class="marking" v-if="recordIds.prevRecordId && type == 1" @click="go('prev')">上一人</el-button>
        <el-button class="marking" v-if="recordIds.nextRecordId && type == 1" @click="go('next')">下一人</el-button>
        <el-button class="marking main" @click="examPost">{{ type == 1 ? "修改" : "提交" }}阅卷</el-button>
      </div>

      <!-- <div class="exam-submit" style="padding-top: 20px">
            <div v-if="recordIds.prevRecordId && type == 1" class="item">
              <p @click="go('prev')">上一人</p>
            </div>
            <div v-if="recordIds.nextRecordId && type == 1" class="item" style="border-bottom: none">
              <p @click="go('next')">下一人</p>
            </div>
            <el-button class="exam-post" @click="examPost">提交阅卷</el-button>
          </div> -->
    </template>
  </dsf-exam-layout>
</template>

<script>
export default {
  name: "ExamMarking",
  provide() {
    return {
      exam: this,
    };
  },
  data() {
    return {
      examLoading: false,
      disabled: false,
      examInfoData: {},
      // answeredCount: 0,
      // markedCount: 0,
      recordIds: {},
      type: null,
    };
  },
  computed: {},
  watch: {
    "$route.query"(val, old) {
      if (val.id !== old.id) {
        this.queryData();
      }
    },
  },
  created() {
    this.type = this.$route.query?.type;
    // 获取试卷信息
    this.queryData();
  },
  mounted() {},
  methods: {
    // checkExamscore(subjects, examIndex, type) {
    //   if (subjects.score < subjects.resScore || subjects.error) {
    //     this.$refs[type][examIndex].$refs.input.style.borderColor = "#F56C6C";
    //   } else {
    //     this.$refs[type][examIndex].$refs.input.style.borderColor = "#DCDFE6";
    //   }
    // },
    queryData() {
      this.examLoading = true;
      this.$http
        .get(
          "/inspect/getInspectRecordById",
          {
            recordId: this.$route.query.id,
            typeId: this.type,
          },
          $$webRoot.exam
        )
        .done((res) => {
          if (res.data) {
            // 加载放到请求接口中  不论加载状态
            let data = res.data.allPaperQuestions;

            data?.items?.forEach((item) => {
              let groupIndex = 0;
              item?.questions.forEach((question) => {
                // 有组合题时
                if (question?.children?.length) {
                  question.resScore = _.sumBy(question.children, (item) => Number(item.resScore)).toFixed(2);
                  _.forEach(question.children, (child) => {
                    child.groupIndex = ++groupIndex;
                    child.resScore = child.handleResults ? child.resScore + "" : "";
                    child.error = false;
                    child.message = "";
                  });
                } else {
                  // 打分
                  question.resScore = question.handleResults ? question.resScore + "" : "";
                  question.error = false;
                  question.message = "";
                  // type == 0 ? "" : question.resScore || question.resScore == 0 ? question.resScore + "" : question.score + "";
                }
              });
            });
            this.examInfoData = data;
            this.recordIds = res.data.recordIds;
            this.examLoading = false;

            if (!res.data.recordIds.nextRecordId) {
              dsf.layer.message("当前为最后一份阅卷", "warning");
            }
          }
        })
        .catch((err) => {
          dsf.layer.message(err.message, false);
        });
    },
    // 提交考试
    examPost() {
      let inspectResDtoList = [];
      let notAnswer = false;
      let over = false;
      this.examInfoData?.items?.forEach((item) => {
        item?.questions.forEach((question) => {
          // console.log(question)
          if (question.resScore === "") {
            notAnswer = true;
          }
          // 有组合题时
          if (question?.children?.length) {
            // 组合题 判断打分和默认分
            _.forEach(question.children, (child) => {
              if (child.resScore === "") {
                notAnswer = true;
              }
              if (child.resScore > child.score || child.error) {
                over = true;
              }
            });
            if (!over) {
              question.resScore = _.sumBy(question.children, (item) => Number(item.resScore)).toFixed(2);
            }
          }
          // console.log('question.resScore', question.resScore)
          // 不是组合题 判断打分和默认分
          if (question.resScore > question.score || question.error) {
            over = true;
          }
          // 组合题添加小题
          if (question?.children?.length) {
            _.forEach(question.children, (item) => {
              inspectResDtoList.push({
                questionId: item.examQuestionsId,
                score: Number(item.resScore),
                property: item.questionsProperty,
                itemsValue: item.items.value,
                treeinfoPid: item.treeinfoPid,
                treeinfoLevel: item.treeinfoLevel,
                settingId: item.settingId,
                questionScore: question.score,
              });
            });
          } else {
            inspectResDtoList.push({
              questionId: question.examQuestionsId,
              score: Number(question.resScore),
              property: question.questionsProperty,
              itemsValue: question.items.value,
              treeinfoPid: question.treeinfoPid,
              treeinfoLevel: question.treeinfoLevel,
              settingId: question.settingId,
              questionScore: question.score,
            });
          }
        });
      });
      if (notAnswer) {
        dsf.layer.message("请给每个主观题都打分", false);
        return;
      }
      if (over) {
        dsf.layer.message("分数验证失败,不能提交", false);
        return;
      }
      if (this.disabled) {
        return;
      }
      this.disabled = true;
      let params = {
        recordId: this.$route.query.id,
        paperId: this.examInfoData.examPaper.value,
        inspectResDtoList: inspectResDtoList,
      };
      // console.log("表单数据", params);
      return this.$http
        .post(
          "/inspect/commitInspectRecord",
          JSON.stringify(params),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
          $$webRoot.exam
        )
        .done((res) => {
          this.disabled = false;
          if (res.success && res.state == 20000) {
            // 刷新父级
            if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
              this.$openerVm = window.opener.openerVms[window.name] || null;
              this.$openerVm?.reloadData();
            }
            if (this.type == 0) {
              if (this.recordIds["nextRecordId"]) {
                dsf.layer.message(res.data);
                this.go("next");
              } else {
                // location.reload();
                dsf.layer
                  .confirm({
                    title: "温馨提示",
                    message: "已阅完所有试卷，是否退出阅卷。",
                    cancelButtonText: "关闭",
                  })
                  .then(() => {
                    window.close();
                  })
                  .catch(() => {});
              }
            } else {
              dsf.layer.message("修改" + res.data);
            }
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => {
          dsf.layer.message(err.message, false);
          this.disabled = false;
        });
    },
    groupScore(subjects) {
      // console.log("11", subjects.resScore, subjects.examQuestionsId);
      let reg = /^\d+(\.\d+)?$/;
      // 有分 并用为正数
      if (subjects.resScore && reg.test(subjects.resScore)) {
        subjects.error = false;
        // 打分大于当前总分
        if (subjects.resScore > subjects.score) {
          subjects.error = true;
          subjects.message = "不能超过当前题总分";
        }
      } else {
        subjects.error = true;
        subjects.message = "请输入正数";
      }
    },
    resetQuestionScore(childValue, subjects, childKey) {
      let reg = /^\d+(\.\d+)?$/;
      // 有分 并用为正数
      if (childValue.resScore && reg.test(childValue.resScore)) {
        childValue.error = false;
        // 打分大于当前总分
        if (childValue.resScore > childValue.score) {
          childValue.error = true;
          childValue.message = "不能超过当前题总分";
          return;
        }
        // 当前题的总分  打分
        if (subjects.items.value == "group") {
          subjects.resScore = _.sumBy(subjects.children, (item) => (item.resScore ? Number(item.resScore) : Number(item.score))).toFixed(2);
        }
      } else {
        childValue.error = true;
        childValue.message = "请输入正数";
      }
    },
    toScroll(examId, childKey) {
      const scrollTop = document.querySelectorAll(".ds-virtual-scroll-box")[1].scrollTop;
      let top = 0;
      if (childKey >= 0) {
        top = document.querySelectorAll("[child-refs]")[childKey].getBoundingClientRect().top;
      } else {
        top = this.$refs["question" + examId][0].getBoundingClientRect().top;
      }
      document.querySelectorAll(".ds-virtual-scroll-box")[1].scrollTo({
        top: top + scrollTop - 60, // 110
        behavior: "smooth", // 平滑滚动
      });
    },
    go(type) {
      this.$router.replace({
        query: { id: this.recordIds[type + "RecordId"], type: this.type },
      });
      // 刷新父级
      if (window.opener?.openerVms && window.opener.openerVms[window.name]) {
        this.$openerVm = window.opener.openerVms[window.name] || null;
        this.$openerVm?.reloadData();
      }

      // const res = await this.examPost();
      // if (res) {
      //   this.$router.replace({
      //     query: { id: this.recordIds[type + "RecordId"] },
      //   });
      // }
    },
  },
};
</script>

<style></style>
